import { useEffect, useState } from "react";
import { SearchInput } from "../../../components";
import styles from './ActiveCleanersTab.module.css';
import { useNavigate } from "react-router-dom";
import { List } from "antd";
import engineer from "../../../assets/profile2.png";
import engineer2 from "../../../assets/man1.png";
import { GoPrimitiveDot } from 'react-icons/go';
import CategoriesMiddleware from "../../../store/Middlewares/CategoriesMiddleware";
import { IMG_URL } from "../../../store/Apis";
import dummyImg from '../../../assets/dummy.png';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ActiveCleanersTab = () => {
  const [search, setsearch] = useState();
  const navigate = useNavigate();

  const dispatch = useDispatch()
  const { t, i18n } = useTranslation();
  const ActiveCleaner = useSelector(state => state.activeCleanersReducer.activeCleaners)
  const activeCleanersPagination = useSelector(state => state.activeCleanersReducer.activeCleanersPagination)

  useEffect(() => {
    getactiveCleaners();
    getLanguage();
  }, []);

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const getactiveCleaners = () => {
    let data = {
      next_page_url: undefined
    }
    dispatch(CategoriesMiddleware.getActiveCleaners(data))

  }

  const onPressLoadMore = () => {
    let data = {
      next_page_url: activeCleanersPagination?.links?.next
    }
    dispatch(CategoriesMiddleware.getActiveCleaners(data))
  };

  const loadMore =
    activeCleanersPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;

  const options = [
    {
      id: 1,
      name: "Hope Fuentes",
      img: engineer,
      designation: 'Custodial Engineer',
      assigned: true,
    },
    {
      id: 2,
      name: "Jackson Bradshaw",
      img: engineer2,
      designation: 'Custodial Engineer',
      assigned: false,
    },
    {
      id: 3,
      name: "Hope Fuentes",
      img: engineer,
      designation: 'Custodial Engineer',
      assigned: true,
    },
    {
      id: 4,
      name: "Jackson Bradshaw",
      img: engineer2,
      designation: 'Custodial Engineer',
      assigned: false,
    },
    {
      id: 5,
      name: "Hope Fuentes",
      img: engineer,
      designation: 'Custodial Engineer',
      assigned: true,
    },
    {
      id: 6,
      name: "Jackson Bradshaw",
      img: engineer2,
      designation: 'Custodial Engineer',
      assigned: false,
    },
  ];
  const renderItem = (item) => {
    return (
      <div
        className={styles.box_item}
        onClick={() =>
          navigate("/Cleaners/ActiveCleaners/Profile", {
            state: item,
          })
        }
      >
        <img src={item?.profile_image ? IMG_URL + item?.profile_image : dummyImg} className={styles.image} />
        <div className={styles.heading_view}>
          <text className={styles.tab_heading}> {item?.name}</text>
          <text className={styles.text}>{t(item?.category_name)}</text>
          <div className={styles.assignedDiv}>
            <GoPrimitiveDot className={styles.dot} color={item?.is_idle == false ? '#56F71E' : '#707070'} />
            {item?.is_idle == false ? <text className={styles.text}>{t("Assigned")}</text> : <text className={styles.Untext}>{t("Unassigned")}</text>}

          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainDiv}>
      {/* <div className={styles.used_search_input}>
        <SearchInput
          placeholder={"Search"}
          onChange={(e) => setsearch(e.target.value)}
        />
      </div> */}
      <List
        style={{ width: "100%" }}
        grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
        dataSource={ActiveCleaner}
        footer={loadMore}
        renderItem={renderItem}
      />
    </div>
  )
};
export default ActiveCleanersTab;